"use client";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useState, type FormEvent } from "react";
import { accountRequest } from "../api-client";

export default function Login() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await accountRequest("/api/accounts/login", "POST", { email, password });
      router.replace("/");
      router.refresh();
    } catch (error) {
      setError((error as Error).message);
      setBusy(false);
    }
  }
  return (
    <main className="admin-login-page">
      <form className="admin-login-card" onSubmit={(event) => void submit(event)}>
        <div className="request-brand">
          <span className="request-brand-mark" aria-hidden="true">
            ↗
          </span>
          <span>Specbound</span>
        </div>
        <h1>Sign in</h1>
        <p>Use your private beta account.</p>
        <label htmlFor="account-email">Email</label>
        <input
          id="account-email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          maxLength={254}
          required
        />
        <label htmlFor="account-password">Password</label>
        <input
          id="account-password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          maxLength={128}
          required
        />
        {error && (
          <p role="alert" className="admin-error">
            {error}
          </p>
        )}
        <button type="submit" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <details>
          <summary>Forgot your password?</summary>
          <p>
            Email recovery is not available yet. Ask the site owner for a private recovery link.
          </p>
        </details>
        <Link href="/request">Use an invite code or request access</Link>
      </form>
    </main>
  );
}
